<template>
  <v-container
    id="aderencia-bdgd-historico"
    fluid
    tag="section"
  >
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-file-compare"
          inline
          class="ml-0 px-5 py-4"
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Aderência BDGD
            </div>
          </template>

          <v-btn
            id="btn-nova-aderencia-bdgd"
            color="success"
            dark
            elevation="1"
            class="mt-5"
            style="float:left"
            relative
            text
            medium
            @click="$router.push(`edit`)"
          >
            <v-icon
              left
              size="30px"
            >
              mdi-plus-circle
            </v-icon>
            Nova Aderência BDGD
          </v-btn>

          <v-text-field
            id="aderencia-bdgd-historico-search"
            v-model="search"
            append-icon="mdi-magnify"
            class="break-search bs-aderencia-bdgd ml-auto mt-4"
            label="Procurar"
            hide-details
            single-line
            style="max-width: 250px;"
          />

          <general-progress-bars
            class="mt-11"
            :items="downloadProgressData"
            prefix-text="Baixando Aderência BDGD"
          />

          <v-divider class="mt-10" />

          <v-data-table
            class="aderencia-bdgd-table"
            :headers="headers"
            :items="aderencias"
            :search.sync="search"
            :header-props="{
              sortByText: 'Ordenar Por'
            }"
            :footer-props="{
              itemsPerPageText: 'Itens por Página'
            }"
            no-data-text="Nenhuma aderência BDGD disponível"
            no-results-text="Nenhum registro correspondente encontrado"
            mobile-breakpoint="800"
          >
            <template v-slot:[`item.id`]="{ item }">
              {{ item.id }}
            </template>
            <template v-slot:[`item.nome`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    class="text-truncate-column"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ item.nome }}
                  </div>
                </template>
                <span>{{ item.nome }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.usuario`]="{ item }">
              {{ item.usuario }}
            </template>
            <template v-slot:[`item.base`]="{ item }">
              {{ item.base }}
            </template>
            <template v-slot:[`item.tucs`]="{ item }">
              <div v-if="item.tucs.length == 1">
                {{ item.tucs[0] }}
              </div>
              <div v-else>
                <a
                  @click.stop="
                    dialogTucs = true;
                    dialogTucsData = item.tucs;
                  "
                >
                  {{ item.tucs.length }}
                </a>
              </div>
            </template>
            <template v-slot:[`item.executed`]="{ item }">
              {{ item.executed }}
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <general-status :status="item.status" />
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                id="action-download-aderencia-bdgd"
                :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
                :disabled="item.status != 'SUCESSO'"
                color="gray"
                min-width="0"
                class="px-1"
                fab
                icon
                x-small
                :loading="
                  downloadProgressData[item.id] !== undefined ? true : false
                "
                @click="downloadItem(item)"
              >
                <v-icon small>
                  mdi-download
                </v-icon>
              </v-btn>
              <v-menu 
                v-if="item.status == 'SUCESSO' || canRunItem(item) || canDeleteItem(item)"
                offset-y
                right
              >
                <template 
                  v-slot:activator="{ on, attrs }"
                >
                  <v-btn
                    id="action-more-aderencia-bdgd"
                    color="white"
                    class="ml-1"
                    height="22px"
                    width="22px"
                    fab
                    x-small
                    elevation="1"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small>
                      mdi-dots-vertical
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="item.status == 'SUCESSO'"
                    @click="$router.push(`grafico/${item.id}`)"
                  >
                    <v-list-item-icon class="mx-0 my-0 py-4">
                      <v-icon small>
                        mdi-chart-box
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Visualizar Gráfico
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="canRunItem(item)"
                    @click="executarAderenciaBdgd(item.id)"
                  >
                    <v-list-item-icon class="mx-0 my-0 py-4">
                      <v-icon small>
                        mdi-play
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Executar
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="canDeleteItem(item)"
                    @click="openDeleteDialog(item)"
                  >
                    <v-list-item-icon class="mx-0 my-0 py-4">
                      <v-icon small>
                        mdi-trash-can-outline
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Deletar
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="openDialogDetalhes(item)"
                  >
                    <v-list-item-icon class="mx-0 my-0 py-4">
                      <v-icon small>
                        mdi-file-find-outline
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Detalhes
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:[`footer`]>
              <v-switch
                v-if="$store.getters.userIsAdmin"
                class="pa-0 pl-2 swithInterna"
                style="position: absolute" 
                color="primary"
                label="Exibir Expirados"
                dense
                @change="processamentosExpirados = $event, getAllAderencias()"
              />
            </template>
          </v-data-table>
        </base-material-card>

        <dialog-delete
          :show-dialog="dialogDelete"
          @changeValue="dialogDelete = $event"
          @deleteTriggered="deletarAderenciaBdgd(dialogDeleteData.id)"
        >
          <template slot="title">
            Deletar Aderência BDGD #{{ dialogDeleteData.id }}
          </template>
          <template slot="body">
            Tem certeza que deseja deletar <strong>{{ dialogDeleteData.nome }}</strong>? 
          </template>
        </dialog-delete>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialogTucs"
      width="400"
    >
      <v-card>
        <v-card-title class="headline">
          TUCs Selecionadas
        </v-card-title>
        <v-card-text class="">
          {{ dialogTucsData.join(", ") }}.
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="success"
            text
            @click="dialogTucs = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <general-dialog-detalhes
      ref="dialogDetalhes"
      title="Detalhes"
      :show-dialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          :headers="dialogDetalhesHeader"
          :items="dialogDetalhesData"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
          mobile-breakpoint="10"
        />
      </template>
    </general-dialog-detalhes>
  </v-container>
</template>

<script>
import AderenciaBdgdService from '@/services/AderenciaBdgdService';
import dayjs from 'dayjs';
import tourMixins from '@/mixins/tourMixins';
import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';
import DateFormatterMixins from '@/mixins/dateFormatterMixins.js';
import pusherMixins from '@/mixins/pusherMixins';

export default {
  
  components: {
    DialogDelete: () => import('@/components/general/DialogDelete'),
    GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
    GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
    GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes')
  },
  mixins: [powerupsActionsMixins, DateFormatterMixins, pusherMixins, tourMixins],

  data() {
    return {
      processamentosExpirados: false,
      powerupService: AderenciaBdgdService,
      powerupEntityName: 'Aderencia_BDGD',
      arrTour: [
        {
          element: '#btn-nova-aderencia-bdgd',
          intro: 'Clicando neste botão você poderá criar novos relatórios de aderência de BDGD.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#aderencia-bdgd-historico-search',
          intro: 'Neste campo você poderá pesquisar por relatórios de aderência de BDGD já existentes.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#action-download-aderencia-bdgd',
          intro: 'Clicando neste ícone você poderá fazer o download em .XLSX do resultado de seu relatório de aderência de BDGD.',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#action-more-aderencia-bdgd',
          intro: 'Aqui você acessa outras opções para seu relatório de aderência de BDGD, como visualizar gráfico, executá-lo novamente ou deletá-lo.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ],
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Nome',
          value: 'nome'
        },
        {
          text: 'Usuário',
          value: 'usuario'
        },
        {
          text: 'Base',
          value: 'base'
        },
        {
          text: 'TUCs',
          value: 'tucs',
          sortable: false
        },
        {
          text: 'Executado',
          value: 'executed'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ],
      aderencias: [],
      search: '',
      dialogTucs: false,
      dialogTucsData: [],
      dialogDelete: false,
      dialogDeleteData: { id: undefined, nome: undefined },
      downloadProgressData: {}
      
    };
  },

  computed: {
    user() {
      return this.$store.getters.getUser;
    }
  },
  
  mounted() {
    this.getAllAderencias();
    this.subscribe();
  },


  methods: {
    subscribe() {
      this.pusherChannel.bind('refreshAderenciaBdgd', () => {
        this.getAllAderencias();
      });
    },

    getAllAderencias() {
      AderenciaBdgdService.getAderencias(this.processamentosExpirados)
        .then(response => {
          this.aderencias = [];

          response.data.aderencias.forEach(val => {
            this.aderencias.push({
              id: val.id,
              nome: val.nome,
              usuario: val.usuario.nome,
              usuario_id: val.usuario.id,
              tucs: JSON.parse(val.tucs),
              base: val.tipo_base,
              executed: val.executado_em
                ? dayjs(val.executado_em).format('DD/MM/YYYY HH:mm')
                : '-',
              status: val.status,
              dataBaseAis: val.data_base_ais ? this.formatMonth(val.data_base_ais) : '-',
              dataBaseBdgd: val.data_base_bdgd ? this.formatMonth(val.data_base_bdgd) : '-',
              tipoBase: val.tipo_base,
              incluirChfusCom: val.incluir_chfus_com
            });
          });
        })
        .catch(err => {
          console.log('Erro: ', err);
          this.$toast.error('Erro ao carregar relatórios de Aderência BDGD.', '', { position: 'topRight' });
        })
        .finally(()=>{
          this.iniciarTourPagina();
        });
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
      let arrTourFormatted = this.aderencias.length ? this.arrTour : this.arrTour.splice(0, 2);
      this.iniciarTour(arrTourFormatted);
    },

    openDeleteDialog(aderencia) {
      this.dialogDeleteData = {
        id: aderencia.id,
        nome: aderencia.nome
      };

      this.dialogDelete = true;
    },

    deletarAderenciaBdgd(id) {
      this.dialogDelete = false;
      
      AderenciaBdgdService.excluirAderenciaBdgd(id)
        .then(res => {
          this.getAllAderencias();
          this.$toast.success('Aderência BDGD excluída com sucesso.', '', { position: 'topRight' });
        })
        .catch(err => {
          this.$toast.error('Erro ao excluir Aderência BDGD.', '', { position: 'topRight' });
          console.log('Erro: ', err);
        });
    },

    executarAderenciaBdgd(id) {
      AderenciaBdgdService.executarAderenciaBdgd(id)
        .then(() => {
          this.$toast.info('Sua planilha será gerada em instantes. Por favor, aguarde.', '', { position: 'topRight', timeout: 2000 });
          this.getAllAderencias();
        })
        .catch(err => {
          this.$toast.error('Erro ao executar Aderência BDGD.', '', { position: 'topRight' });
          console.log('Erro: ', err);
        });
    },

    openDialogDetalhes(aderencia) {     
        
      this.dialogDetalhesData = [
        {
          parametro: 'NOME:',
          valor: aderencia.nome
        },
        {
          parametro: 'DATA BASE AIS:',
          valor: aderencia.dataBaseAis
        },
        {
          parametro: 'DATA BASE BDGD:',
          valor: aderencia.dataBaseBdgd
        },
        {
          parametro: 'TIPO DE BASE:',
          valor: aderencia.tipoBase
        },
        {
          parametro: 'INCLUI CHFUS COM?:',
          valor: aderencia.incluirChfusCom ? 'Sim' : 'Não'
        },
        {
          parametro: 'TUCS:',
          valor: aderencia.tucs.join(', ')
        }
      ];

      this.dialogDetalhes = true;
    }

  }
};
</script>

<style>
@media screen and (min-width: 800px) {
  .aderencia-bdgd-table table tr td:nth-child(2) {
    max-width: 200px;
  }

  .aderencia-bdgd-table table tr td:nth-child(7),
  .aderencia-bdgd-table table tr td:nth-child(8) {
    white-space: nowrap !important;
  }
}

@media screen and (max-width: 480px) {
  .bs-aderencia-bdgd {
    width: 235.86px !important;
  }
}

.swithInterna label {
  font-size: 13px !important;
  margin-left: 0px !important;
}

</style>